import { useEffect, useMemo, useRef, useState } from 'react';
import { throttle } from './index';

export const useNewestData = <T>(data: T) => {
    const newestdata = useRef<T>();

    useEffect(() => {
        newestdata.current = data;
    }, [data]);

    return newestdata;
};

export const useListenerWindowWidthChange = (triggerConditions: number[]) => {
    const oldTriggerCondition = useRef(0);
    const [widthInfo, setWidthInfo] = useState(`0_${triggerConditions[0]}`);

    useEffect(() => {
        const handleResizeChange = throttle(() => {
            // console.log(window.innerWidth);
            let info = '';
            triggerConditions.forEach((item, index) => {
                if (window.innerWidth < item && oldTriggerCondition.current >= item) {
                    oldTriggerCondition.current = window.innerWidth;
                    info = `${item}_${triggerConditions[index + 1] || 'infinity'}`;
                    return;
                }
                if (oldTriggerCondition.current < item) {
                    oldTriggerCondition.current = window.innerWidth;
                    info = `${triggerConditions[index - 1] || 0}_${item}`;
                }
            });
            if (info) setWidthInfo(info);
        }, 1000);
        if (triggerConditions.length) {
            addEventListener('resize', handleResizeChange);
        }
        return () => {
            removeEventListener('resize', handleResizeChange);
        };
    }, []);

    return widthInfo;
};

export const useControlDrawerTransform = (params: { isFlex?: boolean; animationTime?: number; needTransition?: boolean } = {}) => {
    const { isFlex = false, animationTime = 500, needTransition = true } = params;
    const [display, setDisplay] = useState<'block' | 'none' | 'flex'>('none');
    const [visible, setVisible] = useState(false);

    const showDrawer = () => {
        setDisplay(isFlex ? 'flex' : 'block');
        setTimeout(() => setVisible(true), 1);
    };

    const hideDrawer = () => {
        setVisible(false);
        setTimeout(() => setDisplay('none'), animationTime);
    };

    const style = useMemo(() => {
        return {
            display,
            transform: visible ? 'translateY(0)' : 'translateY(110%)',
            transition: needTransition ? 'transform .5s cubic-bezier(0.25, 0.1, 0.25, 1.0)' : 'none',
        };
    }, [visible, display]);

    return {
        style,
        visible,
        showDrawer,
        hideDrawer,
    };
};
